import type { Article } from "@/types/content";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

interface FeatureGridProps {
  articles: Article[];
}

export default function FeatureGrid({ articles }: FeatureGridProps) {
  return (
    <section className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16">
      <SectionHeading
        eyebrow="Behind The Lens"
        title="幕后直击"
        desc="从现场调度到剪辑取舍，每一篇都尽量把「为什么这么做」讲清楚。"
        to="/category/onsite"
        linkText="更多现场报道"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {articles.map((item) => (
          <ArticleCard key={item.id} article={item} />
        ))}
      </div>
    </section>
  );
}